const API_BASE = process.env.REACT_APP_API_BASE_URL || '';
const JSON_HEADERS = { 'Content-Type': 'application/json' };

const handleResponse = async (response) => {
  let data = null;
  try {
    data = await response.json();
  } catch (_) {
    data = null;
  }

  if (!response.ok) {
    const message = data?.detail || data?.message || 'Unable to complete request';
    throw new Error(message);
  }
  return data;
};

export const getAccount = async (token) => {
  if (!token) throw new Error('Missing access token');
  const response = await fetch(`${API_BASE}/account`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return handleResponse(response);
};

export const updateAccount = async (token, updates) => {
  if (!token) throw new Error('Missing access token');
  const response = await fetch(`${API_BASE}/account`, {
    method: 'PATCH',
    headers: {
      ...JSON_HEADERS,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(updates),
  });
  return handleResponse(response);
};
